export class ClarityEventHandler {
    eventsMap: Map<HTMLElement | null, () => void>

    constructor(eventsMap: Map<HTMLElement | null, () => void>) {
        this.eventsMap = eventsMap
    }

    private getTrackedElement(e: PointerEvent) {
        if (e.target instanceof Element) {
            return e.target.closest("[track-event]")
        }
        return
    }

    private handleEvent(e) {
        const trackedElement = this.getTrackedElement(e)
        if (!trackedElement) {
            return
        }

        const eventFunction = this.eventsMap.get(trackedElement as HTMLElement)

        if (eventFunction) {
            eventFunction()
            return
        }
    }

    clickEvents() {
        if (this.eventsMap.size === 0) {
            return
        }
        document.addEventListener("click", this.handleEvent.bind(this))
    }
}
